module.exports = __webpack_public_path__ + "img/building.90d2b302.svg";